<template>
  <div class="main-block">
    <div class="table -users-group-users-table-">
      <div class="table__header">
        <div class="table__header-inner">
          <p class="table__title">Список пользователей</p>
          <div v-if="$permissionsUpdate" class="table__buttons">
            <Button class="-s-" :class="{ '-disabled-': gettingUsers }" @click="openAside">
              Настройки команды
            </Button>
          </div>
        </div>
      </div>
      <div class="table__body">
        <div class="table__body-block">
          <div class="table__nav">
            <ul class="table__nav-list">
              <li class="table__col">
                <p class="table__col-title">Имя</p>
              </li>
              <li class="table__col">
                <p class="table__col-title">Email</p>
              </li>
            </ul>
          </div>
          <div class="table__content">
            <template v-if="gettingUsers">
              <SkeletonRow v-for="i in 5" :key="i"></SkeletonRow>
            </template>
            <template v-else>
              <TableRow v-for="user in teammates" :key="user.id" :user="user"></TableRow>
              <SkeletonRow v-if="isAddingPage"></SkeletonRow>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TableRow from './components/Row';
import SkeletonRow from './components/SkeletonRow';
import replaceRouteQuery from '@/functions/replaceMultipleRouteQuery';
import { mapState, mapActions } from 'vuex';

export default {
  components: { TableRow, SkeletonRow },
  computed: {
    ...mapState('auth', {
      $permissions: s => s.data.user.permissions.userTeamModuleAdmin
    }),
    ...mapState('usersTeamMembers', {
      teammates: s => s.data.teammates,
      team: s => s.data.team,
      gettingUsers: s => s.meta.gettingUsers,
      isAddingPage: s => s.meta.isAddingPage
    })
  },
  destroyed() {
    this.clearUsers();
  },
  methods: {
    ...mapActions('usersTeamMembers', [
      'getCourse',
      'setAsideMeta',
      'setAsideData',
      'addPage',
      'clearUsers'
    ]),
    openAside() {
      this.setAsideData({ path: 'teammates', value: this.teammates });
      this.setAsideData({ path: 'team', vslue: this.team });
      this.setAsideMeta({ path: 'isOpen', value: true });
    },
    addingPage(page) {
      this.addPage(page);
      replaceRouteQuery([{ value: page, name: 'page', methods: 'replace' }]);
    }
  }
};
</script>
